import React, { createContext, useReducer, useContext, useMemo } from 'react';

const PageContext = createContext();

function pageReducer(state, action) {
  return { ...state, [action.type]: action.payload };
}

const PageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(pageReducer, {});

  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};

const usePageContext = () => {
  const context = useContext(PageContext);

  if (context === undefined) {
    throw new Error('usePageContext must be used within a Provider');
  }
  return {
    dispatch: context.dispatch,
    state: context.state,
  };
};

export { PageProvider, usePageContext };
